<template>
  <div class="civil-engineering-content">
    <div class="content-section">
      <div class="input-section" :class="{ 'edit-mode': editingId }">
        <div class="input-row">
          <div class="input-item">
            <span class="input-title">名称：</span>
            <input
              type="text"
              v-model="currentItem.name"
              placeholder="输入名称"
              class="input-field"
            />
          </div>
          <div class="input-item">
            <span class="input-title">单位：</span>
            <input
              type="text"
              v-model="currentItem.unit"
              placeholder="输入单位"
              class="input-field"
            />
          </div>
          <div class="input-item">
            <span class="input-title">数量：</span>
            <input
              type="number"
              v-model.number="currentItem.quantity"
              placeholder="输入数量"
              min="0"
              step="1"
              class="input-field"
            />
          </div>
          <div class="input-item">
            <span class="input-title">占地面积（㎡）：</span>
            <input
              type="number"
              v-model.number="currentItem.area"
              placeholder="输入占地面积"
              min="0"
              step="0.01"
              class="input-field"
            />
          </div>
          <div class="input-item">
            <span class="input-title">结构：</span>
            <input
              type="text"
              v-model="currentItem.structure"
              placeholder="输入结构"
              class="input-field"
            />
          </div>
          <div class="input-item">
            <span class="input-title">单位造价（元）：</span>
            <input
              type="number"
              v-model.number="currentItem.unitPrice"
              placeholder="输入单位造价"
              min="0"
              step="0.01"
              class="input-field"
            />
          </div>
          <button class="btn btn-primary" @click="handleAddOrUpdate">
            {{ editingId ? "修改" : "添加" }}
          </button>
          <button v-if="editingId" class="btn btn-default" @click="cancelEdit">
            取消
          </button>
        </div>
      </div>

      <div class="table-container">
        <div class="table-header">
          <div class="th-cell th-seq">序号</div>
          <div class="th-cell th-name">名称</div>
          <div class="th-cell">单位</div>
          <div class="th-cell">数量</div>
          <div class="th-cell">占地面积（㎡）</div>
          <div class="th-cell">结构</div>
          <div class="th-cell">单位造价（元）</div>
          <div class="th-cell">金额（万元）</div>
          <div class="th-cell">操作</div>
        </div>
        <div class="table-body-wrapper">
          <div class="table-body">
            <div
              v-for="(item, index) in tableData"
              :key="item.id"
              class="data-row"
            >
              <div class="td-cell th-seq">{{ index + 1 }}</div>
              <div class="td-cell td-name">{{ item.name }}</div>
              <div class="td-cell">{{ item.unit }}</div>
              <div class="td-cell">{{ item.quantity }}</div>
              <div class="td-cell">
                {{ item.area !== undefined && item.area !== null && item.area !== 0 ? item.area.toFixed(2) : "" }}
              </div>
              <div class="td-cell">{{ item.structure }}</div>
              <div class="td-cell">
                {{ item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== 0 ? item.unitPrice.toFixed(2) : "" }}
              </div>
              <div class="td-cell">
                {{ item.amount !== undefined && item.amount !== null && item.amount !== 0 ? item.amount.toFixed(2) : "" }}
              </div>
              <div class="td-cell">
                <button class="btn-link" @click="editItem(item)">修改</button>
                <button class="btn-link btn-delete" @click="deleteItem(index)">
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-footer">
          <div class="td-cell th-seq"></div>
          <div class="td-cell total-label">合计</div>
          <div class="td-cell"></div>
          <div class="td-cell"></div>
          <div class="td-cell"></div>
          <div class="td-cell"></div>
          <div class="td-cell"></div>
          <div class="td-cell total-value">
            {{ totalAmount !== undefined && totalAmount !== null && totalAmount !== 0 ? totalAmount.toFixed(2) : "" }}
          </div>
          <div class="td-cell"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// comp计算器
import { totalTable, deprecia } from "@/utils/comp.js";

export default {
  name: "CivilEngineering",
  data() {
    return {
      currentItem: {
        name: "",
        unit: "",
        quantity: 0,
        area: 0,
        structure: "",
        unitPrice: 0,
      },
      tableData: [],
      installationCost: 0,
      otherCosts: 0,
      editingId: null,
      projectData: {},
    };
  },
  computed: {
    totalAmount() {
      return this.tableData.reduce((sum, item) => sum + item.amount, 0);
    },
    totalCost() {
      return this.totalAmount + this.installationCost + this.otherCosts;
    },
  },
  watch: {
    tableData: {
      handler() {
        this.updateVuex();
      },
      deep: true,
    },
    installationCost: {
      handler() {
        this.updateVuex();
      },
    },
    otherCosts: {
      handler() {
        this.updateVuex();
      },
    },
  },
  mounted() {
    this.loadFromVuex();
  },
  methods: {
    loadFromVuex() {
      this.projectData = this.$store.state.projectData || {};
      const investmentEstimate = this.projectData["总投资估算"] || {};
      const civilData = investmentEstimate["建筑费用"] || {};
      this.setFormData(civilData);
    },
    addItem() {
      if (
        !this.currentItem.name ||
        !this.currentItem.unit ||
        !this.currentItem.quantity ||
        !this.currentItem.unitPrice
      ) {
        this.$toast.warning("请填写完整的项目信息");
        return;
      }

      const newItem = {
        id: Date.now(),
        ...this.currentItem,
        amount:
          (this.currentItem.quantity * this.currentItem.unitPrice) / 10000,
      };

      this.tableData.push(newItem);
      this.resetForm();

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    editItem(item) {
      this.editingId = item.id;
      this.currentItem = {
        name: item.name,
        unit: item.unit,
        quantity: item.quantity,
        area: item.area || 0,
        structure: item.structure || "",
        unitPrice: item.unitPrice,
      };
    },
    handleAddOrUpdate() {
      if (this.editingId) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    updateItem() {
      if (
        !this.currentItem.name ||
        !this.currentItem.unit ||
        !this.currentItem.quantity ||
        !this.currentItem.unitPrice
      ) {
        this.$toast.warning("请填写完整的项目信息");
        return;
      }

      const index = this.tableData.findIndex(
        (item) => item.id === this.editingId
      );
      if (index !== -1) {
        const amount =
          (this.currentItem.quantity * this.currentItem.unitPrice) / 10000;

        this.tableData.splice(index, 1, {
          ...this.currentItem,
          id: this.editingId,
          amount: amount,
        });
      }

      this.resetForm();

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    cancelEdit() {
      this.resetForm();
    },
    resetForm() {
      this.currentItem = {
        name: "",
        unit: "",
        quantity: 0,
        area: 0,
        structure: "",
        unitPrice: 0,
      };
      this.editingId = null;
    },
    deleteItem(index) {
      this.tableData.splice(index, 1);

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    getFormData() {
      return {
        合计: this.totalAmount,
        tableData: this.tableData,
      };
    },
    setFormData(data) {
      this.tableData = data["tableData"] || [];
      // 不直接修改计算属性totalAmount，而是通过设置tableData来间接影响它
      // totalAmount会根据tableData自动计算
      this.tableData.forEach((item) => {
        if (!item.id) {
          item.id = Date.now() + Math.random();
        }
        item.quantity = item.quantity || 0;
        item.area = item.area || 0;
        item.unitPrice = item.unitPrice || 0;
        item.amount = item.amount || 0;
      });
    },
    updateVuex() {
      const civilData = this.getFormData();
      // 确保数据结构完整
      if (!this.projectData.总投资估算) {
        this.projectData.总投资估算 = {};
      }
      this.projectData.总投资估算.建筑费用 = civilData;
      this.$store.commit("SET_PROJECT_DATA", this.projectData);

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
  },
};
</script>

<style scoped>
.civil-engineering-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
}

.content-section {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.input-section {
  flex-shrink: 0;
  padding: 8px 15px;
  border-bottom: 1px solid #e4e7ed;
}

.input-section.edit-mode {
  border: 2px solid #409eff;
  background-color: #f0f7ff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: nowrap;
}

.input-item {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.input-title {
  display: inline-block;
  margin-right: 5px;
  color: #303133;
  font-size: 14px;
  white-space: nowrap;
}

.input-field {
  width: 100px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  box-sizing: border-box;
}

.input-field:focus {
  border-color: #409eff;
  outline: none;
}

.btn {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  height: 28px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.btn-primary {
  background: #409eff;
  color: white;
  border: none;
}

.btn-primary:hover {
  background: #66b1ff;
}

.btn-default {
  background: white;
  color: #606266;
  border: 1px solid #dcdfe6;
  margin-left: 8px;
}

.btn-default:hover {
  color: #409eff;
  border-color: #409eff;
}

.table-container {
  position: relative;
  width: 99.5%;
  flex: 1;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.table-header {
  display: flex;
  flex-shrink: 0;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.table-body-wrapper {
  flex: 1;
  overflow: auto;
}

.table-body {
  display: flex;
  flex-direction: column;
}

.table-footer {
  display: flex;
  flex-shrink: 0;
  background: #ecf5ff;
  border-top: 1px solid #e4e7ed;
}

.th-cell {
  padding: 8px 10px;
  border-right: 1px solid #e4e7ed;
  text-align: center;
  font-weight: 600;
  color: #303133;
  font-size: 12px;
  flex: 1;
}

.th-cell:last-child {
  border-right: none;
}

.th-seq {
  flex: none;
  width: 60px;
}

.th-name {
  text-align: left;
}

.td-name {
  text-align: left;
}

.table-body .data-row {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
}

.data-row {
  background: white;
}

.data-row:hover {
  background: #f5f7fa;
}

.td-cell {
  padding: 8px 10px;
  border-right: 1px solid #e4e7ed;
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.td-cell:last-child {
  border-right: none;
}

.td-cell.th-seq {
  flex: none;
  width: 60px;
  text-align: center;
}

.btn-link {
  background: none;
  border: none;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
  padding: 0 5px;
}

.btn-link:hover {
  text-decoration: underline;
}

.btn-delete {
  color: #f56c6c;
}

.btn-delete:hover {
  text-decoration: underline;
}

.total-label {
  text-align: right;
  font-weight: bold;
  color: #303133;
}

.total-value {
  text-align: center;
  font-weight: bold;
  color: #f56c6c;
}
</style>
